import React from 'react';
import { Box, Typography } from '@mui/material';
import { useUiTheme } from 'framework/uiTheme';

const BetaBadgeWrapper = ({ children, text = 'Beta' }: { children: React.ReactNode; text?: string }) => {
  const { Badge } = useUiTheme();

  return (
    <Box position="relative">
      {text ? (
        <Badge
          sx={{
            position: 'absolute',
            right: '-10px',
            minHeight: 'auto',
            top: '-8px',
            fontSize: 10,
            '.MuiChip-label': {
              fontWeight: 'normal',
              overflow: 'visible',
              textOverflow: 'initial',
              p: '2px 4px',
            },
          }}
          color="primary"
        >
          {text}
        </Badge>
      ) : null}

      <Typography>{children}</Typography>
    </Box>
  );
};

export default BetaBadgeWrapper;
